export default function encodeLabel(label) {
  if (label) {
    return label.replace(/[?!. ]+/, "-")
  }

  return "";
}
